<template>
  <div class="app-footer">
    <div class="footer-container">
      <!--左对齐 -->
      <div class="flex-left">
        <div class="yszx-desc master">
          <img src="@/assets/imgs/home/logo.png" class="desc-title" />
          <p class="yszx-content">科技赋能<span>让智慧教育触手可及</span></p>
        </div>
        <div class="yszx-apps master">
          <ul class="apps-link">
            <li>
              <a href="https://edu.yunsizhixue.com/cloud/home" target="_blank"
                >教育云平台</a
              >
            </li>
            <li>
              <a
                href="http://open.yunsizhixue.com/document/#/docs/1-%E5%BC%80%E5%8F%91%E5%BF%85%E8%AF%BB/1-%E5%BA%94%E7%94%A8%E7%B1%BB%E5%9E%8B%E4%BB%8B%E7%BB%8D"
                target="_blank"
                >开发者文档</a
              >
            </li>
            <li>
              <a :href="`${prePathOpen}app-stores`" target="_blank">应用商店</a>
            </li>
          </ul>
          <div class="apps-info">
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              >京ICP备2021036633号-4</a
            >
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038621"
              target="_blank"
              >京公网安备11010802038621号</a
            >
            <span
              >©{{ getCurrentYear() }} 开发者：北京云思智学科技有限公司</span
            >
          </div>
        </div>
      </div>

      <!-- 右对齐 -->
      <div class="flex-right">
        <img src="@/assets/imgs/home/QR-code.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Footer',
  setup() {
    const prePathOpen =
      process.env.NODE_ENV === 'production' ? '/static/open-platform/' : '/'
    const getCurrentYear = () => {
      return new Date().getFullYear()
    }
    return {
      getCurrentYear,
      prePathOpen
    }
  }
})
</script>

<style lang="less" scoped>
.app-footer {
  height: 180px;
  width: 100%;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  background: #36405e;
  .master {
    height: 72px;
    margin: 54px 0;
  }

  .footer-container {
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;

    .flex-left {
      display: flex;
      .yszx-desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .desc-title {
          height: 30px;
          width: 114px;
        }
        .yszx-content {
          line-height: 30px;
          font-weight: 500;
          width: 192px;
          white-space: nowrap;
          span {
            margin-left: 10px;
          }
        }
      }

      .yszx-apps {
        margin-left: 80px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .apps-link {
          font-weight: 600;
          li {
            display: inline-block;
            line-height: 30px;
            &:nth-child(-n + 2) {
              margin-right: 72px;
            }
          }
        }
        .apps-info {
          line-height: 30px;
          font-weight: 500;
          a {
            margin-right: 40px;
          }
        }
      }
    }

    .flex-right {
      img {
        width: 120px;
        height: 120px;
        margin-top: 30px;
      }
    }
  }
}
</style>
